





































import BravadoButtonV3 from '@/components/common/BravadoButtonV3/BravadoButtonV3.vue';
import { commonModalNames } from '@/components/common/constants';
import BravadoLogo from '@/components/global/BravadoLogo/BravadoLogo.vue';
import type { PropOptions } from 'vue';
// FIXME: we can't use search for unauthporized users because search doesn't respond without token
// import Search from '@/components/common/Search/Search.vue';

export default {
  name: 'HeaderGuest',
  components: {
    BravadoLogo,
    BravadoButtonV3,
    // Search,
  },
  props: {
    withNavbar: {
      type: Boolean,
      default: true,
    } as PropOptions<boolean>,
  },
  data() {
    return { commonModalNames };
  },
  computed: {
    rootPath() {
      return '/war-room/posts';
    },
  },
  methods: {
    handleLoginClick(): void {
      // @ts-ignore
      this.$analytics.logEvent('war-room__header__login-link__click');
      // @ts-ignore
      this.$modal.showWithRoute('SIGN_IN_MODAL');
    },
    handleSignUpClick(): void {
      // @ts-ignore
      this.$analytics.logEvent('war-room__header__signup-button__click');
      // @ts-ignore
      this.$modal.showWithRoute('WAR_ROOM_SIGN_UP_MODAL');
    },
  },
};
